import { styles as nodeStyles } from 'flow-builder/renderers/node/nodeStyles';

import type { NodeT } from '../../../../types';

export type Point = [number, number];
export type Bounds = { start: Point; end: Point };

export function getStartBounds(actions: NodeT[]): Bounds {
  const initBounds: Point = [actions[0].pageX, actions[0].pageY];
  const bounds = actions.reduce<Bounds>(
    (acc, { pageX, pageY }) => {
      if (acc.start[0] > pageX) {
        acc.start[0] = pageX;
      }

      if (acc.start[1] > pageY) {
        acc.start[1] = pageY;
      }

      if (acc.end[0] < pageX) {
        acc.end[0] = pageX;
      }

      if (acc.end[1] < pageY) {
        acc.end[1] = pageY;
      }

      return acc;
    },
    { start: [...initBounds], end: [...initBounds] },
  );

  bounds.end[0] += nodeStyles.base.width;
  /*
   * We don't actually know how high the node is at this time, so we guestimate.
   * This will only slightly affect the Y center point.
   */
  bounds.end[1] += 100;

  return bounds;
}
